import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { IBillingSettingsModel } from '@models/billing-settings.model';
import { IInvoiceModel } from '@models/invoice.model';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  constructor(private http: HttpClient) {}

  public postAddCard(token: string): Observable<any> {
    return this.http.post<any>(`${environment.api_url}/billing-settings/add-card`, {
      card_authorization_token: token,
    });
  }

  public getBillingSettings(): Observable<IBillingSettingsModel> {
    return this.http.get<IBillingSettingsModel>(`${environment.api_url}/billing-settings`);
  }

  public getInvoices(): Observable<IInvoiceModel[]> {
    return this.http.get<IInvoiceModel[]>(`${environment.api_url}/invoices`);
  }
}
